import React from 'react';
import PropTypes from 'prop-types';
import ReactLinkpile from '@homeaway/react-linkpile';
import {connect} from 'react-redux';
import {defineMessages, injectIntl, FormattedMessage} from 'react-intl';
import {pushEdapEvent} from '../../../utils/edap';

export const messages = defineMessages({
    linkpileProperties: {
        id: 'linkpile.properties',
        defaultMessage: 'UNTRANSLATED'
    },
    citiesLinkpileTab: {
        id: 'linkpile.tabs.cities',
        defaultMessage: 'UNTRANSLATED'
    },
    neighborhoodsLinkpileTab: {
        id: 'linkpile.tabs.neighborhoods',
        defaultMessage: 'UNTRANSLATED'
    },
    poiLinkpileTab: {id: 'linkpile.tabs.poi', defaultMessage: 'UNTRANSLATED'},
    popularLinkpileTab: {
        id: 'linkpile.tabs.popular',
        defaultMessage: 'UNTRANSLATED'
    },
    statesLinkpileTab: {
        id: 'linkpile.tabs.states',
        defaultMessage: 'UNTRANSLATED'
    },
    touristicAreasLinkpileTab: {
        id: 'linkpile.tabs.touristicAreas',
        defaultMessage: 'UNTRANSLATED'
    },
    premisesLinkpileTab: {
        id: 'linkpile.tabs.premises',
        defaultMessage: 'UNTRANSLATED'
    }
});

function mapStateToProps(state) {
    return {
        destination: state.destination
    };
}

export class LinkpileComponent extends React.Component {
    static propTypes = {
        destination: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        hideTabs: PropTypes.bool
    };

    static defaultProps = {
        hideTabs: false
    };

    formatTabs(tabs) {
        const {intl: {formatMessage, formatNumber}, hideTabs} = this.props;

        if (!tabs) {
            return null;
        }

        return tabs.map((tab) => ({
            name: hideTabs
                ? ''
                : formatMessage(messages[`${tab.name}LinkpileTab`]),
            links: tab.links.map((link) => ({
                ...link,
                subtitle: formatMessage(messages.linkpileProperties, {
                    inventoryCount: formatNumber(link.propertyCount)
                })
            }))
        }));
    }

    handleItemClick(item) {
        return () => {
            const eventOptions = {
                actionlocation: 'destination-linkpile',
                eventlbsuuid: item.lbsId,
                eventrefinements: item.type
            };
            const edapOptions = {delayProcessing: true};
            pushEdapEvent('destination.link.click', eventOptions, edapOptions);
        };
    }

    render() {
        const {destination, title} = this.props;
        const tabs = this.formatTabs(destination.linkPileTabs);

        if (!tabs || tabs.length < 1) {
            return null;
        }

        return (
            <div className="container linkpile-container">
                <div className="row">
                    <div className="col-xs-12">
                        <h2>
                            <FormattedMessage
                                {...title}
                                values={{
                                    ...(title && title.values || {}),
                                    destinationName: (
                                        <span className="linkpile-destination">
                                            {destination.details.simpleName}
                                        </span>
                                    )
                                }}
                            />
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <ReactLinkpile
                            tabs={tabs}
                            handleItemClick={this.handleItemClick}
                            hideTabs={this.props.hideTabs}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const Linkpile = injectIntl(connect(mapStateToProps)(LinkpileComponent));
